import { Box } from "@mui/material";
import { alpha } from "@mui/material/styles";

const colorScheme = {
  blue: "#00b8d9",
  green: "#22c55d",
  yellow: "#ffab00",
  red: "#ff5631",
};

// Icon badge for the reporting stat cards
function ComponentRadialChart({ icon: IconComponent, color }) {
  const iconColor = colorScheme[color] ?? colorScheme.blue;
  return (
    <Box
      sx={{
        width: 56,
        height: 56,
        borderRadius: "14px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: alpha(iconColor, 0.12),
      }}
    >
      <IconComponent sx={{ fontSize: 30, color: iconColor }} />
    </Box>
  );
}

export default ComponentRadialChart;
